(function ($) {
  Drupal.behaviors.r4_hero = {
    attach: function (context, settings) {
      $('#r4_mod1', context).once('r4_hero', function () {
        // Animating the Flares.
        var flareInit1 = new TimelineMax({ repeat: -1 });
        var flare1 = $('#r4_hero_flare_1');

        flareInit1.set(flare1, { opacity: '1' });
        flareInit1.to(flare1, 3, { opacity: .1 });
        flareInit1.to(flare1, 2, { opacity: .8 });

        var flareInit2 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare2 = $('#r4_hero_flare_2');

        flareInit2.set(flare2, { opacity: '0.1' });
        flareInit2.to(flare2, 3, { opacity: 1 });
        flareInit2.to(flare2, 4, { opacity: .5 });

        var flareInit3 = new TimelineMax({ repeat: -1 });
        var flare3 = $('#r4_hero_flare_3');

        flareInit3.set(flare3, { opacity: '.4' });
        flareInit3.to(flare3, 2, { opacity: .5 });
        flareInit3.to(flare3, 1, { opacity: 1 });
        flareInit3.to(flare3, 0.5, { opacity: .5 });
        flareInit3.to(flare3, 0.5, { opacity: .2 });

        var flareInit4 = new TimelineMax({ repeat: -1 });
        var flare4 = $('#r4_hero_flare_4');

        flareInit4.set(flare4, { opacity: '1' });
        flareInit4.to(flare4, 3, { opacity: .5 });

        var flareInit5 = new TimelineMax({ repeat: -1 });
        var flare5 = $('#r4_hero_flare_5');

        flareInit5.set(flare5, { opacity: '.5' });
        flareInit5.to(flare5, 3, { opacity: 1 });
        flareInit5.to(flare5, 2, { opacity: .7 });

        var flareInit6 = new TimelineMax({ repeat: -1 });
        var flare6 = $('#r4_hero_flare_6');

        flareInit6.set(flare6, { opacity: '.6' });
        flareInit6.to(flare6, 2, { opacity: .2 });
        flareInit6.to(flare6, 2, { opacity: .7 });

        var flareInit7 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare7 = $('#r4_hero_flare_7');

        flareInit7.set(flare7, { opacity: '.5' });
        flareInit7.to(flare7, 2, { opacity: 1 });
        flareInit7.to(flare7, 1, { opacity: .2 });

        var flareInit8 = new TimelineMax({ repeat: -1 });
        var flare8 = $('#r4_hero_flare_8');

        flareInit8.set(flare8, { opacity: '.75' });
        flareInit8.to(flare8, 2, { opacity: 1 });
        flareInit8.to(flare8, 3, { opacity: .6 });
        flareInit8.to(flare8, 2, { opacity: .85 });
        flareInit8.to(flare8, 1, { opacity: .4 });

        var flareInit9 = new TimelineMax({ repeat: -1 });
        var flare9 = $('#r4_hero_flare_9');

        flareInit9.set(flare9, { opacity: '.3' });
        flareInit9.to(flare9, 2, { opacity: .8 });
        flareInit9.to(flare9, 1, { opacity: 0.2 });

        var flareInit10 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare10 = $('#r4_hero_flare_10');

        flareInit10.set(flare10, { opacity: '0' });
        flareInit10.to(flare10, 1, { opacity: 1 });
        flareInit10.to(flare10, 2, { opacity: .5 });

        var flareInit11 = new TimelineMax({ repeat: -1 });
        var flare11 = $('#r4_hero_flare_11');

        flareInit11.set(flare11, { opacity: '.5' });
        flareInit11.to(flare11, 3, { opacity: 1 });
        flareInit11.to(flare11, 2, { opacity: .2 });

        var flareInit12 = new TimelineMax({ repeat: -1 });
        var flare12 = $('#r4_hero_flare_12');

        flareInit12.set(flare12, { opacity: '.4' });
        flareInit12.to(flare12, 2, { opacity: .5 });
        flareInit12.to(flare12, 3, { opacity: 1 });
        flareInit12.to(flare12, 0.5, { opacity: .6 });
        flareInit12.to(flare12, 0.5, { opacity: .5 });

        var flareInit13 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare13 = $('#r4_hero_flare_13');

        flareInit13.set(flare13, { opacity: '.5' });
        flareInit13.to(flare13, 2, { opacity: 1 });
        flareInit13.to(flare13, 3, { opacity: .2 });

        var flareInit14 = new TimelineMax({ repeat: -1 });
        var flare14 = $('#r4_hero_flare_14');

        flareInit14.set(flare14, { opacity: '0' });
        flareInit14.to(flare14, 2, { opacity: 1 });
        flareInit14.to(flare14, 2, { opacity: .5 });

        var flareInit15 = new TimelineMax({
          repeat: -1,
          delay: 1
        });
        var flare15 = $('#r4_hero_flare_15');

        flareInit15.set(flare15, { opacity: '1' });
        flareInit15.to(flare15, 1, { opacity: .2 });
        flareInit15.to(flare15, 2, { opacity: .7 });

        var flareInit16 = new TimelineMax({ repeat: -1 });
        var flare16 = $('#r4_hero_flare_16');

        flareInit16.set(flare16, { opacity: '.4' });
        flareInit16.to(flare16, 2, { opacity: .2 });
        flareInit16.to(flare16, 2, { opacity: 1 });

        var flareInit17 = new TimelineMax({ repeat: -1 });
        var flare17 = $('#r4_hero_flare_17');

        flareInit17.set(flare17, { opacity: '1' });
        flareInit17.to(flare17, 3, { opacity: .2 });
        flareInit17.to(flare17, 2, { opacity: .6 });

        var flareInit18 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare18 = $('#r4_hero_flare_18');

        flareInit18.set(flare18, { opacity: '.5' });
        flareInit18.to(flare18, 2, { opacity: .8 });
        flareInit18.to(flare18, 1, { opacity: .3 });

        var flareInit19 = new TimelineMax({ repeat: -1 });
        var flare19 = $('#r4_hero_flare_19');

        flareInit19.set(flare19, { opacity: '.4' });
        flareInit19.to(flare19, 1, { opacity: .8 });

        var flareInit20 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare20 = $('#r4_hero_flare_20');

        flareInit20.set(flare20, { opacity: '0.2' });
        flareInit20.to(flare20, 3, { opacity: 1 });
        flareInit20.to(flare20, 4, { opacity: .6 });

        var flareInit21 = new TimelineMax({ repeat: -1 });
        var flare21 = $('#r4_hero_flare_21');

        flareInit21.set(flare21, { opacity: '.2' });
        flareInit21.to(flare21, 1, { opacity: .6 });
        flareInit21.to(flare21, 2, { opacity: 1 });

        var flareInit22 = new TimelineMax({
          repeat: -1,
          delay: 2
        });
        var flare22 = $('#r4_hero_flare_22');

        flareInit22.set(flare22, { opacity: '0.3' });
        flareInit22.to(flare22, 1, { opacity: 1 });

        var flareInit23 = new TimelineMax({ repeat: -1 });
        var flare23 = $('#r4_hero_flare_23');

        flareInit23.set(flare23, { opacity: '.2' });
        flareInit23.to(flare23, 2, { opacity: 1 });
        flareInit23.to(flare23, 2, { opacity: 0.5 });

        var flareInit24 = new TimelineMax({ repeat: -1 });
        var flare24 = $('#r4_hero_flare_24');

        flareInit24.set(flare24, { opacity: '.5' });
        flareInit24.to(flare24, 3, { opacity: 1 });
        flareInit24.to(flare24, 2, { opacity: .2 });

        var flareInit25 = new TimelineMax({ repeat: -1 });
        var flare25 = $('#r4_hero_flare_25');

        flareInit25.set(flare25, { opacity: '.5' });
        flareInit25.to(flare25, 2, { opacity: 1 });
      });
    }
  };
})(jQuery);
